import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import theme from './theme-style'
import RobotoThin from '../fonts/Roboto-Thin.ttf'
import RobotoLight from '../fonts/Roboto-Light.ttf'
import RobotoRegular from '../fonts/Roboto-Regular.ttf'
import RobotoMedium from '../fonts/Roboto-Medium.ttf'
import RobotoBold from '../fonts/Roboto-Bold.ttf'
import RobotoBlack from '../fonts/Roboto-Black.ttf'
import { NAVBAR_HEIGHT } from './constants'
import pxToRem from '../utils/pxToRem'
import { deviceMax } from './breakpoints'
import { buildSpacingCSS } from './spacing-utils';

const GlobalStyle = createGlobalStyle`
  ${reset}

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url(${RobotoThin}) format("truetype");
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(${RobotoLight}) format("truetype");
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${RobotoRegular}) format("truetype");
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${RobotoMedium}) format("truetype");
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${RobotoBold}) format("truetype");
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(${RobotoBlack}) format("truetype");
  }

  * {
    word-wrap: break-word;
  }

  *, *:before, *:after, html {
    box-sizing: border-box;
  }

  *:focus {
    -webkit-tap-highlight-color: transparent;
  }

  html {
    height: 100%;
  }

  html,
  body {
    position: relative;
  }

  body {
    min-height: 100%;
    font-size: ${theme.fonts.weight.base};
    line-height: 1.5;
    font-weight: ${theme.fonts.weight.normal};
    font-style: normal;
    font-stretch: normal;
    font-family: ${theme.fonts.family.sans};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    letter-spacing: normal;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: none;
    background-color: ${theme.colors.secondary.grey90}
  }

  #gatsby-focus-wrapper {
    display: flex;
    flex-direction: column;
    padding-top: ${pxToRem(NAVBAR_HEIGHT.desktop)};
    min-height: 100vh;
    @media ${deviceMax.tablet} {
    padding-top: ${pxToRem(NAVBAR_HEIGHT.mobile)};
    }
  }

  ul,
  menu,
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6
  p {
    font-family: ${theme.fonts.family.sans};
    margin: 0;
  }

  a,
  button {
    transition: opacity .3s;
    font-family: ${theme.fonts.family.sans};
  }

  img {
    max-width: 100%;
  }

  img[src*=base64\\\\,

  ]
  {
    image-rendering: -moz-crisp-edges
  ;
    image-rendering: crisp-edges
  ;
  }
  /* width for vertical scroll bar // height for horizontal scroll bar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #E5E5E5;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #8B8D8E;
    border-radius: 10px;
  }
`

const SpacingUtilities = createGlobalStyle`
  ${buildSpacingCSS()}
`;


export default { GlobalStyle, SpacingUtilities }

